var _desc, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSaudiArabia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 21,
    viewBox: "0 0 3 2",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "Flag of Saudi Arabia") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "desc"
  }, "Green field with the Shahada and a sword in white, centered")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 2,
    fill: "#005430"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.5,1)"
  }, /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: -0.08,
    textAnchor: "middle",
    dominantBaseline: "middle",
    fontFamily: "Amiri, 'Scheherazade New', 'Noto Naskh Arabic', serif",
    fontSize: 0.35,
    fill: "#FFFFFF",
    direction: "rtl"
  }, "\n      \u0644\u0627 \u0625\u0644\u0647 \u0625\u0644\u0627 \u0627\u0644\u0644\u0647 \u0645\u062D\u0645\u062F \u0631\u0633\u0648\u0644 \u0627\u0644\u0644\u0647\n    "), /*#__PURE__*/React.createElement("path", {
    d: "       M 0.65 0.22       c -0.08 0.10 -0.30 0.18 -0.62 0.18       c -0.36 0 -0.72 -0.09 -0.98 -0.25       c -0.03 -0.02 -0.03 -0.05 0 -0.07       c 0.06 -0.04 0.13 -0.07 0.20 -0.10       c 0.23 0.11 0.52 0.17 0.78 0.17       c 0.25 0 0.46 -0.05 0.58 -0.12       c 0.03 -0.02 0.06 -0.01 0.07 0.02       z       M 0.73 0.18       h 0.20       c 0.03 0 0.05 0.02 0.05 0.05       v 0.06       c 0 0.03 -0.02 0.05 -0.05 0.05       h -0.20       c -0.03 0 -0.05 -0.02 -0.05 -0.05       v -0.06       c 0 -0.03 0.02 -0.05 0.05 -0.05       z",
    fill: "#FFFFFF",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaudiArabia);
export default __webpack_public_path__ + "static/media/saudiArabia.56f55fbcfe35413a30871448e94485ec.svg";
export { ForwardRef as ReactComponent };